import { useContext } from "react";
import { UserContext } from "../context/User.context";
export const whiteListeSuperAdmin = [
  "admin@oseo.ch",
  "fmorciano@oseo-vs.ch",
  "michael@thecomputerfirm.com",
];

export const isSuperAdmin = (userProps = undefined) => {

  let usedUser;

  if (userProps === undefined) {
    const { user } = useContext(UserContext);

    usedUser = user;
  } else {
    usedUser = userProps;
  }

  if (
    whiteListeSuperAdmin.includes(usedUser.email) ||
    usedUser.subRoles.includes("superAdmin")
  ) {
    return true;
  } else {
    return false;
  }
};
